import Head from 'next/head'
import type { ReactNode } from 'react'
import { BrandLogoLink } from 'shared/components/brand-logo-link'
import { NavbarBase } from 'shared/components/navbar/components/navbar-base'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names'
import { twMerge } from 'tailwind-merge'

interface PublicLayoutProps {
  browserTabTitle: string
  children: ReactNode
}

export function PublicLayout({ browserTabTitle, children }: PublicLayoutProps) {
  const { t } = useLocoTranslation()

  return (
    <>
      <Head>
        <title>{t(browserTabTitle)}</title>
      </Head>
      <NavbarBase>
        <BrandLogoLink />
      </NavbarBase>
      <main className={twMerge(CONTENT_CLASSNAME, 'py-5')}>{children}</main>
    </>
  )
}
